
import React, {Link, Component} from 'react';
import { Filter, FormDataConsumer, BooleanField, TextInput, ReferenceField, Pagination, DateField, ReferenceManyField, Datagrid,TextField, Show,useTranslate, TabbedShowLayout, Tab, ImageField } from 'react-admin';
import { EditButton, ListButton } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { Form } from 'react-final-form'
import Divider from '@material-ui/core/Divider';
import {DocApproveButton, DocRejectButton, DeleteButton, AvatarButton} from '../../control/button/index';
import ActivateIcon from '@material-ui/icons/Check';
import NotActivateIcon from '@material-ui/icons/Clear';
import ImageViewer from '../../control/viewer/image-viewer';

import CardActions from '@material-ui/core/CardActions';

import {DocNameField, FileCountField, ActivityTypeField, 
    ClientDataField, ValidityDateField, PhotoField,
    DocStatusReasonField, DocStatusField, OrderStatusField, FormattedDateField, DriverStatusField, AvatarField, GenderField, ValidateField,
DriverCompanyTypeField,
ValidateHorizonField} from '../../control/field/index'
import {VehicleLockButton, VehicleUnlockButton, VehicleDateEditButton, 
    VehicleApproveButton, VehicleRejectButton,
    DocDateEditButton, ValidateButton, CustomerLockButton, CustomerUnlockButton} from '../../control/button/index'

import {Status, DataStatus, FALSE, TRUE, USER_TYPE_COMPANY_AND_DRIVER, USER_TYPE_AUTO_ENTERPRENER, ACTIVITY_TYPE_ATR, ACTIVITY_TYPE_VTC, UB_TYPE_REPRESENTATIVE, UB_TYPE_EXECUTIVE, UB_TYPE_DIRECTOR, UB_TYPE_OWNER} 
        from '../../util/constant'
import {BACKEND_FILE_URL, theme} from '../../util/variant'

import { makeStyles } from '@material-ui/core/styles';
import { getStripeConnectDueName, normalizeStripeConnectDues } from '../../util/function';

const useStyles = makeStyles({
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
    colorLabel: { paddingLeft: 50, color: '#c30040',},

    colorPrimary: {color:'#c30040',},
    
    noColorLabel: {paddingLeft: 50,  
    },

    colorValue: {color: '#c30040',paddingLeft:5},

    supplementText: {color: '#c30040',},

    noHeader:{display:'none',
    // height:'1px'
    },

    image:{width:'200px',height:'200px',}
    
});

const styles = {
    flex: { display: 'flex'},
    images:{display: 'flex', paddingLeft:'1em', marginLeft:"3em" },
    flexColumn: { display: 'flex', flexDirection: 'column', },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
    map:{ flex: 1, marginTop: '1em', marginBottom: '1em' },
    button:{ flex: 1, marginTop: '1em'},
};

const cardActionStyle = {
    // zIndex: 2,
    // display: 'inline-block',
    // float: 'right',
    zIndex: 2,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    padding: 0,
};

// const DocNameField = ({record, label}) => {
//     // const classes = useStyles();
//     console.log('Doc record: ' + JSON.stringify(record));
//     // if(typeof(record) !== 'undefined' && typeof(record.name) !== 'undefined'){
//     //     const nameObj = JSON.parse(record.name);
//     //     // const empty = record.files.length > 0? '(' + record.files.length + ')' : ''; 
//     //     // return <div><span>{nameObj.fr}</span><span className={classes.supplementText}>{empty}</span></div>
//     //     return <div><span>{nameObj.fr}</span></div>;
//     // }
//     if(typeof(record) !== 'undefined' && typeof(record.doc_name) !== 'undefined'){
//         // const nameObj = JSON.parse(record.name);
//         // const empty = record.files.length > 0? '(' + record.files.length + ')' : ''; 
//         // return <div><span>{nameObj.fr}</span><span className={classes.supplementText}>{empty}</span></div>
//         return <div><span>{record.doc_name}</span></div>;
//     }
//     return <div/>;
    
// }

// DocNameField.defaultProps = {
//     addLabel:true
// }

// const FileCountField = ({record, label}) => {
//     const classes = useStyles();
//     console.log('Doc record: ' + JSON.stringify(record));
//     if(typeof(record) !== 'undefined' && typeof(record.name) !== 'undefined'){
//         return <div><span className={classes.colorValue}>{record.files.length}</span></div>
//     }
    
//     return <div><span className={classes.colorValue}>0</span></div>
    
// }

// FileCountField.defaultProps = {
//     addLabel:true
// }


const ShowActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        
        {/* Add your custom actions */}
        {/* <Button color="primary" onClick={changePassword}>CHANGER LE MOT DE PASSE</Button> */}
        {/* <Link to="/change-password">Changer le mot de passe</Link> */}
        {typeof data != 'undefined' &&  typeof data.validated != 'undefined' && data.validated == FALSE &&
            <ValidateButton basePath={basePath} record={data} resource={resource}/>
        }
        {/* {typeof data != 'undefined' &&  typeof data.locked != 'undefined' && data.locked === Status.UNLOCKED &&
            <CustomerLockButton basePath={basePath} record={data} resource={resource}/>
        }
        {typeof data != 'undefined' &&  typeof data.locked != 'undefined' && data.locked === Status.LOCKED &&
            <CustomerUnlockButton basePath={basePath} record={data} resource={resource}/>
        } */}
        
        <DeleteButton resource="driver" basePath={basePath} record={data} content="Êtes-vous sûr de vouloir supprimer ce chauffeur? Toutes les donnnées personnelles de ce chauffeur seront supprimées"/>
        <EditButton basePath={basePath} record={data} />
        <ListButton basePath={basePath}/>
        {/* <BackButton/> */}

    </CardActions>
);

const Title = ({ record }) => {
    const translate = useTranslate();
    return <span>{translate('resources.driver_company.show')}: {record ? `${record.email}` : ''}</span>;
};



// const UserTypeField = ({ record = {}, label}) => {
//     return <div>
//         <Typography variant="body2">
//             {record.user_type == USER_TYPE_COMPANY_AND_DRIVER? 'Autre' : 'Auto-entrepreneur'}
//         </Typography>
//     </div>;
// }

// UserTypeField.defaultProps = {
//     addLabel: true,
// };


// const DocStatusReasonField = ({ record = {}, label}) => {
//     const classes = useStyles();
//     const statusData = record.status_data;
//     if(typeof(statusData) !== 'undefined' && statusData !== null && statusData !== ''){
//         const statusObj = JSON.parse(statusData); 
//         // return <span>{statusObj.reason}</span>;
//         return <Typography variant="body2" className={classes.colorPrimary}>{statusObj.reason}</Typography>
//     }
//     //     return <Typography variant="body2">
//     //     {statusData.reason}
//     // </Typography>
//     return <span></span>;
// }

// DocStatusReasonField.defaultProps = {
//     addLabel: true,
// };

// const ClientDataField = ({ record = {}, source, label}) => {
//     const client = record.client;
//     if(typeof(client) !== 'undefined' && client !== null && client !== ''){
//         const clientObj = JSON.parse(client); 
//         return <Typography variant="body2">{clientObj[source]}</Typography>
//     }
    
//     return <span></span>;
// }

// ClientDataField.defaultProps = {
//     addLabel: true,
// };


// const ValidityDateField = ({ record = {}, label}) => {
//     const classes = useStyles();
//     return record.date_id !== "" ? <div><br/>
//             <Typography variant="body2" className={classes.noColorLabel}>
//             Date de validité: {record.date !== "" ? <DateField className={classes.colorValue} source="date" record={record} label=""  locales="fr-FR"/> : '--'}
//             <DocDateEditButton record={record}/>
//         </Typography><br/>
//     </div> : '';
// }

// const PhotoField = ({ record = {}, source, label}) => {
//     // const classes = useStyles();
//     return <ImageViewer files={[]} fileUrl={record[source]} title={label} width='60' height='60' round='50%'/>
        
// }

const ManagersField = ({ record = {}, basePath}) => {
    const classes = useStyles();
    if(record === null || record === "undefined") return <div/>;
    return record.user_type === USER_TYPE_COMPANY_AND_DRIVER ? 
    <div>
<Typography style={{ fontWeight: 600, fontSize:15 }}>Cadres</Typography>
                
                
                <ReferenceManyField basePath={basePath} pagination={<Pagination />} reference="customer_manager" target="driver_id" addLabel={false} filter={{'type': UB_TYPE_EXECUTIVE}}>
                <Datagrid expand={<ManagerDocContentPanel/>} expandHeader={<div/>}>
                        {/* <DocNameField label="Liste de documents d'activité du chauffeur"/> */}
                        <TextField label="Nom" source="last_name"/>
                        <TextField label="Prénom" source="first_name"/>
                        <FormattedDateField label="De de naissance" source="birth_date"/>
                        <TextField label="Adresse" source="address"/>
                        <TextField label="Code postal" source="postal_code"/>
                        <TextField label="Ville" source="city"/>
                        {/* <DocStatusField source="status" label="État"/>
                        <DocStatusReasonField label="Motif de refus"/> */}
                        {/* <RejectDocButtonX label="Actions"/>
                        <ApproveDocButton label="Actions"/> */}
                        {/* <OpenFileButton/> */}
                        
                    </Datagrid>
                </ReferenceManyField>
                
                <ValidateHorizonField basePath={basePath} source="executive_done" label= "La saisie des Cadres est complétée" style={{'width':'600px'}}/>
                <p/>

                <Typography style={{ fontWeight: 600, fontSize:15 }}>Directeur Général</Typography>
                
                <ReferenceManyField basePath={basePath} pagination={<Pagination />} reference="customer_manager" target="driver_id" addLabel={false} filter={{'type': UB_TYPE_DIRECTOR}}>
                <Datagrid expand={<ManagerDocContentPanel/>} expandHeader={<div/>}>
                        {/* <DocNameField label="Liste de documents d'activité du chauffeur"/> */}
                        <TextField label="Nom" source="last_name"/>
                        <TextField label="Prénom" source="first_name"/>
                        <FormattedDateField label="De de naissance" source="birth_date"/>
                        <TextField label="Adresse" source="address"/>
                        <TextField label="Code postal" source="postal_code"/>
                        <TextField label="Ville" source="city"/>
                        {/* <DocStatusField source="status" label="État"/>
                        <DocStatusReasonField label="Motif de refus"/> */}
                        {/* <RejectDocButtonX label="Actions"/>
                        <ApproveDocButton label="Actions"/> */}
                        {/* <OpenFileButton/> */}
                        
                    </Datagrid>
                </ReferenceManyField>
                
                <ValidateHorizonField basePath={basePath} source="director_done" label= "La saisie des Directeurs généraux est complétée" style={{'width':'600px'}}/>
                <p/>

                <Typography style={{ fontWeight: 600, fontSize:15 }}>Associés</Typography>
                
                <ReferenceManyField basePath={basePath} pagination={<Pagination />}  reference="customer_manager" target="driver_id" addLabel={false} filter={{'type': UB_TYPE_OWNER}}>
                <Datagrid expand={<ManagerDocContentPanel/>} expandHeader={<div/>}>
                        {/* <DocNameField label="Liste de documents d'activité du chauffeur"/> */}
                        <TextField label="Nom" source="last_name"/>
                        <TextField label="Prénom" source="first_name"/>
                        <FormattedDateField label="De de naissance" source="birth_date"/>
                        <TextField label="Adresse" source="address"/>
                        <TextField label="Code postal" source="postal_code"/>
                        <TextField label="Ville" source="city"/>
                        {/* <DocStatusField source="status" label="État"/>
                        <DocStatusReasonField label="Motif de refus"/> */}
                        {/* <RejectDocButtonX label="Actions"/>
                        <ApproveDocButton label="Actions"/> */}
                        {/* <OpenFileButton/> */}
                        
                    </Datagrid>
                </ReferenceManyField>
                
                <ValidateHorizonField source="owner_done" label= "La saisie des Associés est complétée" style={{'width':'600px'}}/>
                <p/>
    </div> : <div/>;
}

ManagersField.defaultProps = {
    addLabel: false,
};
const DocContentPanel = ({ id, record, resource }) => {
    const classes = useStyles();
    console.log("File record " + JSON.stringify(record));
    var files = record.files;
    files.forEach(function(file, index){
        if(!file.file_url.startsWith("http://") && !file.file_url.startsWith("https://")){
            file.file_url = BACKEND_FILE_URL + file.file_url;
            files[index] = file;
        }
    }
    , files);

    if(files.length === 0)
        return <div>
        <ValidityDateField record={record}/>
        <Typography variant="body2" className={classes.colorLabel}>Aucun fichier</Typography>
        </div>;
    
    return(
        <div style={styles.flexColumn}>
            <Typography variant="body2" className={classes.noColorLabel}>Fichier(s):</Typography>
            <br/>
            <div style={styles.images}>        
                {files.map(file => {
                    return <ImageViewer files={files} fileUrl={file.file_url} title="" width='300' height='300' className={classes.noColorLabel}/>
                })}
            </div>
            <ValidityDateField record={record}/>
            {/* <div className={classes.noColorLabel}><span>Actions: </span> */}
                {/* {record.date !== '' && <ĐocDateEditButton record={record}/>} */}
                {/* <DocRejectButton record={record}/><DocApproveButton record={record}/></div> */}

        </div>
    )
};



const VehicleDateField = ({ record = {}, label}) => {
    const classes = useStyles();
    return record.circulation_date !== "" ? <div><br/>
            <Typography variant="body2" className={classes.noColorLabel}>
            Date de la 1e mise en circulation: {record.date !== "" ? <DateField className={classes.colorValue} source="circulation_date" record={record} label=""  locales="fr-FR"/> : '--'}
            <VehicleDateEditButton record={record}/>
        </Typography><br/>
    </div> : '';
}

const ManagerDocContentPanel = ({ id, record, resource }) => {
    const classes = useStyles();
    console.log("Manager record " + JSON.stringify(record));
    var idCardRectoUrl = record.id_card_recto_url;
    if(idCardRectoUrl !== '' && !idCardRectoUrl.startsWith("http://") && !idCardRectoUrl.startsWith("https://"))
    idCardRectoUrl = BACKEND_FILE_URL + idCardRectoUrl;

    var idCardVersoUrl = record.id_card_verso_url;
    if(idCardVersoUrl !== '' && !idCardVersoUrl.startsWith("http://") && !idCardVersoUrl.startsWith("https://"))
    idCardVersoUrl = BACKEND_FILE_URL + idCardVersoUrl;

    var addressProofRectoUrl = record.address_proof_recto_url;
    if(addressProofRectoUrl !== '' && !addressProofRectoUrl.startsWith("http://") && !addressProofRectoUrl.startsWith("https://"))
    addressProofRectoUrl = BACKEND_FILE_URL + addressProofRectoUrl;
    
    
    var files = [];
    files[0] = {file_url: idCardRectoUrl, name: "Carte d'identité recto"};
    files[1] = {file_url: idCardVersoUrl, name: "Carte d'identité verso"};
    files[2] = {file_url: addressProofRectoUrl, name: 'Justificatif de domicile'};
    
    return(
       
            <div style={styles.flexColumn}>
                <div style={styles.images}>        
                    {files.map(file => {
                        return <ImageViewer files={files} fileUrl={file.file_url} title={file.name} width='300' height='300'/>
                    })}
                </div>
                {/* <VehicleDateField record={record}/> */}
                {/* <div className={classes.noColorLabel}><span>Actions: </span>
                {console.log("Vehicle is locked = " + record.is_locked)}
                {record.is_locked === Status.UNLOCKED && <VehicleLockButton record={record}/>}
                {record.is_locked === Status.LOCKED && <VehicleUnlockButton record={record}/>}
                {record.status == DataStatus.NEW && 
                <VehicleApproveButton record={record}/>}
                {record.status == DataStatus.NEW && 
                <VehicleRejectButton record={record}/>}
                </div> */}
            </div>
    );
};

const ContentTextField = ({ source, record = {}, label}) => {
    if(typeof(record) !== 'undefined'){
        var content = record['content'];
        if(typeof(content) !== 'undefined' && content !== null)
            content = content.replace(/(<([^>]+)>)/ig,"");
        return <span class="MuiTypography-root MuiTypography-body2">{content}</span>
    }
    return <span></span>
}
    
ContentTextField.defaultProps = {
    addLabel: true,
};

const ListFilter = (props)  => (
    <Filter {...props}>
        <TextInput label="Email" source="email" alwaysOn resettable/>
        <TextInput label="Mobile" source="mobile" alwaysOn resettable/>
        {/* <TextInput label="Nom" source="last_name" alwaysOn resettable/>
        <TextInput label="Prénom" source="first_name" alwaysOn resettable/>
        <SelectInput label="Type" source="user_type" alwaysOn choices={driverTypes} 
            optionText={<UserTypeFilterField />} allowEmpty emptyText="Tous les types" emptyValue='0' 
            initialValue='0'
            />
        
        <TextInput label="Ville" source="city" resettable/>
        <TextInput label="Code postal" source="postal_code" resettable/>
        <SelectInput label="Civilité" source="gender" choices={genders} 
            allowEmpty emptyText="Tous les types" emptyValue='0' initialValue='0'
            optionText={<GenderFilterField />}/>

        <SelectInput label="Activation" source="activated" choices={activateds} 
            allowEmpty emptyText="Tous les deux" emptyValue='-1' initialValue='-1'
            />
        <SelectInput label="Vérrouillage" source="locked" choices={lockeds} 
            allowEmpty emptyText="Tous les deux" emptyValue='-1' initialValue='-1'
            />
        <SelectInput label="Validation" source="validated" choices={validateds} 
            allowEmpty emptyText="Tous les deux" emptyValue='-1' initialValue='-1'
            /> */}
    </Filter>
);

const StripeConnectField = ({ id, record, resource }) => {
    const classes = useStyles();
    if(typeof(record.stripe_account) === 'undefined' || record.stripe_account === 'undefined' || record.stripe_account === null || record.stripe_account === "") 
    return (<div style={styles.flexColumn}>
            <Typography style={{ fontWeight: 600, textDecorationLine: 'underline', fontSize:15 }}>Etat du compte Stripe</Typography>
            <br/>
            <div>Aucun compte</div>
            
        </div>);
    var account = JSON.parse(record.stripe_account);
    console.log("Stripe account " + JSON.stringify(account));
    if(typeof(account) === 'undefined' || account === 'undefined' || account === null) 
    return (<div style={styles.flexColumn}>
            <Typography style={{ fontWeight: 600, textDecorationLine: 'underline', fontSize:15 }}>Etat du compte Stripe</Typography>
            <br/>
            <div>Aucun compte</div>
            
        </div>);
    var eventuallyDues = [];
    console.log("Stripe account type " + account.business_type);
    if(account.business_type === 'individual'){
        var individual = account.individual;
        if(typeof(individual) !== 'undefined' && individual !== 'undefined' && individual !== null){
            eventuallyDues = individual.requirements.eventually_due;
            eventuallyDues = normalizeStripeConnectDues(eventuallyDues);
        }
    }
    // else{
    //     // var company = account.company;
    //     // if(typeof(company) !== 'undefined' && company !== 'undefined' && company !== null){
    //         eventuallyDues = account.requirements.eventually_due;
    //         eventuallyDues = normalizeStripeConnectDues(eventuallyDues);
    //     // }
        
    // }
        
    // requirements.forEach(function(requirement, index){
    //     if(!file.file_url.startsWith("http://") && !file.file_url.startsWith("https://")){
    //         file.file_url = BACKEND_FILE_URL + file.file_url;
    //         files[index] = file;
    //     }
    // }
    // , files);

    // if(eventuallyDues.length === 0)
    //     return account.charges_enabled && account.payouts_enabled ? <div>Transfert activé - Paiement activé
    //     </div> : account.charges_enabled && !account.payouts_enabled ? <div>Transfert activé - Paiement desactivé</div> : <div>Transfert desactivé - Paiement desactivé</div>;
    
    return(
        <div style={styles.flexColumn}>
        <div><Typography style={{ fontWeight: 600, textDecorationLine: 'underline', fontSize:15 }}>Etat du compte Stripe</Typography>
        <StripeConnectStatusField record={record}/></div>
            
            {account.charges_enabled && account.payouts_enabled && <div>Transfert activé - Paiement activé</div>}
            {account.charges_enabled && !account.payouts_enabled && <div>Transfert activé - Paiement désactivé</div>}
            {!account.charges_enabled && !account.payouts_enabled && <div>Transfert désactivé - Paiement désactivé</div>}
            

            <br/>
            {eventuallyDues.length > 0 && <Typography variant="body1">Informations à compléter:</Typography>}
            <br/>
            <div>        
                {eventuallyDues.map(eventuallyDue => {
                    return <div><span><Typography variant="body1"> - {getStripeConnectDueName(eventuallyDue)}</Typography></span></div>;
                })}
                <br/>
            </div>
            {/* <ValidityDateField record={record}/>
            <div className={classes.noColorLabel}><span>Actions: </span> */}
                {/* {record.date !== '' && <ĐocDateEditButton record={record}/>} */}
                {/* <DocRejectButton record={record}/><DocApproveButton record={record}/></div> */}

        </div>
    )
};

const StripeConnectStatusField = ({ id, record, resource }) => {
    const classes = useStyles();
    if(typeof(record.stripe_account) === 'undefined' || record.stripe_account === 'undefined' || record.stripe_account === null || record.stripe_account === "") 
    return <NotActivateIcon color='disabled'/>
    
    var account = JSON.parse(record.stripe_account);
    console.log("Stripe account " + JSON.stringify(account));
    if(typeof(account) === 'undefined' || account === 'undefined' || account === null) 
    return <NotActivateIcon color='disabled'/>;
    var eventuallyDues = [];
    console.log("Stripe account type " + account.business_type);
    if(account.business_type === 'individual'){
        var individual = account.individual;
        if(typeof(individual) !== 'undefined' && individual !== 'undefined' && individual !== null){
            eventuallyDues = individual.requirements.eventually_due;
        }
    }
    else{
        // var company = account.company;
        // if(typeof(company) !== 'undefined' && company !== 'undefined' && company !== null){
            eventuallyDues = account.requirements.eventually_due;
        // }
        
    }

    if(eventuallyDues.length > 0)
        return <NotActivateIcon color='disabled'/>;
    return <ActivateIcon color='primary'/>;
};

StripeConnectStatusField.defaultProps = {
    addLabel: true,
};


// filter={{company_id: record.id}} 
const DriverList = ({ record = {}, ...props}) => {
    console.log('Driver list record id ' + record.id);
return <ReferenceManyField reference="driver" target="company_id" addLabel={false}>
    {/* <List filter={{company_id: record.id}}  filters={<ListFilter />}> */}
                
                    <Datagrid rowClick="show" {...props}>
                    {/* <AvatarField source="photo_url" label="" /> */}
                    {/* <TextField source="id" label="ID"/> */}
                    <TextField source="last_name" label="Nom"/>
                    <TextField source="first_name" label="Prénom"/>
                    <TextField source="mobile" label="Mobile"/>
                    <TextField source="email" label="Email"/>
                    <FormattedDateField source="birth_date" label="Date de naissance"  locales="fr-FR"/>
                    <DriverStatusField source="online_status" label="Statut"/>
                    <FormattedDateField source="create_time" label="Date d'inscription"  locales="fr-FR"/>
                    {/* <ValidateField source="activated" label='Activé'/>*/}
                    
                    <ValidateField source="locked" label='Verrouillé'/> 
                    </Datagrid>
                
                {/* </List> */}
            </ReferenceManyField>
}
// const userId = localStorage.getItem('user_id');
// const role = localStorage.getItem('role');
const orderRowClick = (id, basePath, record) => '#/order/' + record.id;

const ShowDriver = ({staticContext, ...props}) => {
    const translate = useTranslate();
    const classes = useStyles();
  
    return(
        
    <Show component="div" title={<Title />} actions={<ShowActions/>} {...props}>
            <TabbedShowLayout redirect="list">
            <Tab label="Profil">
                {/* <PhotoField source="logo_url" label=""/> */}
                <Typography style={{ fontWeight: 600, fontSize:15 }}>Infos de la société</Typography>
                <DriverCompanyTypeField label="Type d'entreprise"/>
                {/* <ActivityTypeField label="Type d'activité"/> */}
                <TextField source="company_name" label = "Nom de société"/>
                <TextField source="company_address" label = "Adresse "/>
                <div/>
                <TextField source="postal_code" label="Code postal" className={classes.inlineBlock}/>
                <TextField source="city" label="Ville" className={classes.inlineBlock}/>                
                <div/>
                {/* <TextField source="phone" label = "Téléphone" className={classes.inlineBlock}/> */}
                <TextField source="mobile" label = "Mobile" className={classes.inlineBlock}/>
                <TextField source="email" label = "Email" className={classes.inlineBlock}/>

                <TextField source="siren_number" label = "Numéro de SIRET"/>
                <TextField source="iban" label = "IBAN"/>
                <TextField source="vat_no" label = "Numéro TVA Intracommunautaire"/>

                <FormattedDateField source="create_time" label="Date d'inscription"  locales="fr-FR"/>
                {/* <TextField source="activation_code" label="Code d'activation"/> */}
                {/* <Typography variant="body2">État</Typography> */}
                <ValidateField source="activated" label='Activé' className={classes.inlineBlock}/>
                <ValidateField source="validated" label='Validé' className={classes.inlineBlock}/> 
                 <ValidateField source="locked" label='Verrouillé' className={classes.inlineBlock}/>
                 <div/>
                 <TextField source="mode" label='Mode Stripe' className={classes.inlineBlock}/>
                 <ValidateField source="stripe_validated" label='Validé par Stripe' className={classes.inlineBlock}/>
                <br/>
                <Typography style={{ fontWeight: 600, fontSize:15 }}>Représentant légal</Typography>
                <p/>
                <ReferenceManyField reference="customer_manager" target="driver_id" addLabel={false} filter={{'type': UB_TYPE_REPRESENTATIVE}}>
                    <Datagrid expand={<ManagerDocContentPanel/>} expandHeader={<div/>}>
                        {/* <DocNameField label="Liste de documents d'activité du chauffeur"/> */}
                        <TextField label="Nom" source="last_name"/>
                        <TextField label="Prénom" source="first_name"/>
                        <FormattedDateField label="De de naissance" source="birth_date"/>
                        <TextField label="Adresse" source="address"/>
                        <TextField label="Code postal" source="postal_code"/>
                        <TextField label="Ville" source="city"/>
                        {/* <DocStatusField source="status" label="État"/>
                        <DocStatusReasonField label="Motif de refus"/> */}
                        {/* <RejectDocButtonX label="Actions"/>
                        <ApproveDocButton label="Actions"/> */}
                        {/* <OpenFileButton/> */}
                        
                    </Datagrid>
                </ReferenceManyField>
                <br/>
                <ManagersField/>


            </Tab>
            <Tab label="Paramètres">
                <ValidateField label="Voir commandes du jour" source="today_view"/>
                <ValidateField label="Voir toutes les commandes" source="all_view"/>
                <ValidateField label="Recevoir/voir les commandes immédiate" source="immediate_receive"/>
                <ValidateField label="Recevoir/voir les commandes en réservation" source="reservation_receive"/>
                <ValidateField label="Recevoir/voir les commandes payées en carte" source="in_card_receive"/>
                <ValidateField label="Recevoir/voir les commandes payées en espèces" source="in_cash_receive"/>
            </Tab>
              <Tab label="Compte Stripe">
                <StripeConnectField/>
            </Tab>
        
            <Tab label="Documents d'activité">
                <ReferenceManyField reference="doc" target="user_id" addLabel={false}>
                    <Datagrid expand={<DocContentPanel/>} expandHeader={<div/>}>
                        {/* <DocNameField label="Liste de documents d'activité du chauffeur"/> */}
                        <DocNameField label="Nom du document"/>
                        <FileCountField label="Fichiers"/>
                        {/* <DocStatusField source="status" label="État"/>
                        <DocStatusReasonField label="Motif de refus"/> */}
                        {/* <RejectDocButtonX label="Actions"/>
                        <ApproveDocButton label="Actions"/> */}
                        {/* <OpenFileButton/> */}
                        
                    </Datagrid>
                </ReferenceManyField>
                {/* <FileField source="files" src='url' title='title' label="Fichiers" target="_blank"/> */}
                {/* <FileViewer source="files" src='url' /> */}
            </Tab>

            <Tab label="Livreurs">
                {/* <DriverList/> */}
                <ReferenceManyField pagination={<Pagination />} reference="driver_sub" target="company_id" addLabel={false} filter={{'user_type': "7"}}>
                
                    <Datagrid rowClick="show" {...props}>
                    {/* <AvatarField source="photo_url" label="" /> */}
                    {/* <TextField source="id" label="ID"/> */}
                    <TextField source="last_name" label="Nom"/>
                    <TextField source="first_name" label="Prénom"/>
                    <TextField source="mobile" label="Mobile"/>
                    <TextField source="email" label="Email"/>
                    <FormattedDateField source="birth_date" label="Date de naissance"  locales="fr-FR"/>
                    <DriverStatusField source="online_status" label="Statut"/>
                    <FormattedDateField source="create_time" label="Date d'inscription"  locales="fr-FR"/>
                    {/* <ValidateField source="activated" label='Activé'/>
                    <ValidateField source="validated" label='Validé'/>*/}
                    <ValidateField source="locked" label='Verrouillé'/> 
                    </Datagrid>
                </ReferenceManyField>
            </Tab>

            
            <Tab label="Commandes de la société">
                <ReferenceManyField pagination={<Pagination />} reference="order" target="company_id" addLabel={false}>
                        <Datagrid rowClick="show">
                        <TextField source="create_time" label="Date\heure"/>
                        <TextField source="order_number" label="Nº de commande"/>
                        <ClientDataField source="last_name" label="Nom du client"/>
                        <ClientDataField source="first_name" label="Prénom du client"/>
                        <TextField source="from_address" label="Adresse de départ"/>
                        <TextField source="to_address" label="Adresse d'arrivée"/>
                        <TextField source="total" label="Prix(€)"/>
                        <OrderStatusField source="status" label = "État"/>
                        <TextField source="rating_on_driver" label="Note attribué par le client"/>
                        </Datagrid>
                    </ReferenceManyField>
            </Tab>
            
        </TabbedShowLayout>

       
    </Show>
    );
};


export default ShowDriver;